export const createActionSet = actionName => ({
  PENDING: `${actionName}_PENDING`,
  SUCCESS: `${actionName}_SUCCESS`,
  ERROR: `${actionName}_ERROR`
})

/**
 * Maps action values to display-friendly names
 */
const ACTION_DISPLAY_NAMES = {
  add: 'Add Job',
  add_note: 'Note Added',
  clear_user_input: 'User Input Cleared',
  email_opt_in_out: 'Email Preference Changed',
  email_resent: 'Email Resent',
  email_sent: 'Email Sent',
  email_user: 'User Emailed',
  finalized: 'Finalized',
  gen_link: 'Link Generated',
  import: 'Import',
  login: 'Login',
  save_draft: 'Draft Saved',
  save_setting: 'Setting Saved',
  status_update: 'Status Updated',
  update_job: 'Job Updated',
  view: 'Viewed',
}

/**
 * Returns a display-friendly name for an action value
 * Falls back to title-cased version if not in mapping
 * @param {string} action - The action value (e.g., 'add_note')
 * @returns {string} Display-friendly name (e.g., 'Note Added')
 */
export const formatActionName = (action) => {
  if (!action) return ''
  
  // Return mapped name if exists
  if (ACTION_DISPLAY_NAMES[action]) {
    return ACTION_DISPLAY_NAMES[action]
  }
  
  // Fallback: convert snake_case to Title Case
  return action
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}